import FastImage from 'react-native-fast-image';
import MapView from 'react-native-maps';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const MarkerWrapper = styled.View`
  align-items: center;
`;

export const NearestBadge = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(10)}px;
  padding-horizontal: ${RFValue(6)}px;
  padding-vertical: ${RFValue(2)}px;
  margin-bottom: ${RFValue(3)}px;
`;

export const NearestBadgeText = styled.Text`
  color: #fff;
  font-size: ${RFValue(7)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

interface MarkerViewProps {
  isNearest?: boolean;
  isSelected?: boolean;
}

//@ts-ignore
export const MarkerView = styled(FastImage)<MarkerViewProps>`
  width: ${RFValue(40)}px;
  height: ${RFValue(40)}px;
  border-radius: ${RFValue(10)}px;
  border-width: ${({isNearest}) => (isNearest ? 3 : 2)}px;
  border-color: ${({theme, isNearest, isSelected}) =>
    isNearest
      ? theme.colors.primary
      : isSelected
      ? theme.colors.blue
      : theme.colors.image_border};
`;


export const CalloutContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: 12px;
  padding: 10px;
  width: 240px;

  /* Sombra no iOS */
  shadow-color: #222;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.3;
  shadow-radius: 5px;


  z-index: 999;
`;

export const CalloutText = styled.Text`
  color:${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  margin-bottom: 2px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const CalloutSubtext = styled.Text`
  color:${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  margin-bottom: 2px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const CalloutButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: 8px;
  margin-top: ${RFValue(8)}px;
  padding: 8px 12px;
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  align-items: center;
  justify-content: center;
`;

export const CalloutButtonText = styled.Text`
  color: #fff;
  font-size: ${RFValue(10)}px;
  font-weight: 600;
`;

export const CalloutInfosContainer = styled.View`
  flex-direction: row;
  align-items: flex-start;

  gap: ${RFValue(6)}px;
`;

//@ts-ignore
export const CalloutAvatar = styled(FastImage)`
    height: ${RFValue(40)}px;
  width: ${RFValue(40)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(8)}px;
  
`;
export const CalloutInfos = styled.View`
  flex:1;
`;
export const OpenMapIcons = styled.View`
  flex-direction: row;
  align-items: flex-start;
`;

export const MapIcon = styled.Image`
  width: ${RFValue(41)}px;
  border-radius: 30px;
  height: ${RFValue(41)}px;
`;

export const MapTitle = styled.Text`
  font-size: ${RFValue(9)}px;
  text-align: center;
  margin-top: 6px;
  line-height: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const OpenMapsTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(8)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const LinkButtonContainer = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${RFValue(4)}px;
`;
